
import { defineComponent } from 'vue';
import { Alert } from 'CoreHome';
import ChatMessage from './ChatMessage.vue';
import ChatLoading from './ChatLoading.vue';

export default defineComponent({
  components: {
    Alert,
    ChatMessage,
    ChatLoading,
  },
  props: {
    errored: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    streaming: { type: Boolean, default: false },
    messages: { type: Array, default: () => [] },
    aiName: { type: String, required: true },
    aiColor: { type: String, default: '#3450a3' },
  },
});
